"use strict";

require("core-js/modules/es6.array.filter.js");
var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.object.to-string.js");
require("core-js/modules/es6.array.iterator.js");
require("core-js/modules/web.dom.iterable.js");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _gridStyled = require("grid-styled");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _price = _interopRequireDefault(require("@gravity/price"));
var _rangeSlider = _interopRequireDefault(require("@gravity/range-slider"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _jsxFileName = "/codebuild/output/src190565674/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/functional/PriceRangeFilter/lib/PriceRangeFilter.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_1cnbyy3c0f() {
  var path = "/codebuild/output/src190565674/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/functional/PriceRangeFilter/lib/PriceRangeFilter.js";
  var hash = "068441e428b89f06b617cd97fa63ccb5caa6553b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src190565674/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/functional/PriceRangeFilter/lib/PriceRangeFilter.js",
    statementMap: {
      "0": {
        start: {
          line: 12,
          column: 16
        },
        end: {
          line: 14,
          column: 4
        }
      },
      "1": {
        start: {
          line: 16,
          column: 17
        },
        end: {
          line: 32,
          column: 1
        }
      },
      "2": {
        start: {
          line: 34,
          column: 18
        },
        end: {
          line: 36,
          column: 4
        }
      },
      "3": {
        start: {
          line: 38,
          column: 16
        },
        end: {
          line: 38,
          column: 24
        }
      },
      "4": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 45,
          column: 17
        }
      },
      "5": {
        start: {
          line: 47,
          column: 35
        },
        end: {
          line: 47,
          column: 40
        }
      },
      "6": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 51,
          column: 6
        }
      },
      "7": {
        start: {
          line: 55,
          column: 22
        },
        end: {
          line: 62,
          column: 3
        }
      },
      "8": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 59,
          column: 8
        }
      },
      "9": {
        start: {
          line: 56,
          column: 32
        },
        end: {
          line: 59,
          column: 5
        }
      },
      "10": {
        start: {
          line: 61,
          column: 4
        },
        end: {
          line: 61,
          column: 37
        }
      },
      "11": {
        start: {
          line: 66,
          column: 6
        },
        end: {
          line: 66,
          column: 97
        }
      },
      "12": {
        start: {
          line: 67,
          column: 49
        },
        end: {
          line: 67,
          column: 59
        }
      },
      "13": {
        start: {
          line: 68,
          column: 4
        },
        end: {
          line: 88,
          column: 6
        }
      },
      "14": {
        start: {
          line: 92,
          column: 0
        },
        end: {
          line: 102,
          column: 2
        }
      },
      "15": {
        start: {
          line: 104,
          column: 0
        },
        end: {
          line: 107,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 38,
            column: 16
          },
          end: {
            line: 38,
            column: 17
          }
        },
        loc: {
          start: {
            line: 38,
            column: 22
          },
          end: {
            line: 38,
            column: 24
          }
        },
        line: 38
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 44,
            column: 2
          },
          end: {
            line: 44,
            column: 3
          }
        },
        loc: {
          start: {
            line: 44,
            column: 21
          },
          end: {
            line: 52,
            column: 3
          }
        },
        line: 44
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 55,
            column: 22
          },
          end: {
            line: 55,
            column: 23
          }
        },
        loc: {
          start: {
            line: 55,
            column: 38
          },
          end: {
            line: 62,
            column: 3
          }
        },
        line: 55
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 56,
            column: 18
          },
          end: {
            line: 56,
            column: 19
          }
        },
        loc: {
          start: {
            line: 56,
            column: 32
          },
          end: {
            line: 59,
            column: 5
          }
        },
        line: 56
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 64,
            column: 2
          },
          end: {
            line: 64,
            column: 3
          }
        },
        loc: {
          start: {
            line: 64,
            column: 11
          },
          end: {
            line: 89,
            column: 3
          }
        },
        line: 64
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 66,
            column: 6
          },
          end: {
            line: 66,
            column: 97
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 66,
            column: 60
          },
          end: {
            line: 66,
            column: 77
          }
        }, {
          start: {
            line: 66,
            column: 80
          },
          end: {
            line: 66,
            column: 97
          }
        }],
        line: 66
      },
      "1": {
        loc: {
          start: {
            line: 66,
            column: 6
          },
          end: {
            line: 66,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 66,
            column: 6
          },
          end: {
            line: 66,
            column: 23
          }
        }, {
          start: {
            line: 66,
            column: 27
          },
          end: {
            line: 66,
            column: 57
          }
        }],
        line: 66
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "068441e428b89f06b617cd97fa63ccb5caa6553b"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1cnbyy3c0f = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1cnbyy3c0f();
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Wrapper = (cov_1cnbyy3c0f().s[0]++, _styledComponents.default.div.attrs({
  className: 'stx-PriceRangeFilter'
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)([""]))));
var PriceBox = (cov_1cnbyy3c0f().s[1]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_gridStyled.Box).attrs({
  className: 'stx-PriceRangeFilter-PriceBox'
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n      margin-bottom: 1rem;\n    "])))), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n      margin-bottom: 1rem;\n      font-size: ", ";\n      line-height: ", ";\n      font-weight: ", ";\n      color: ", ";\n    "])), _themeMapper.evolutionTheme.priceRange.price.fontSize, _themeMapper.evolutionTheme.priceRange.price.lineHeight, _themeMapper.evolutionTheme.priceRange.price.fontWeight, _themeMapper.evolutionTheme.priceRange.price.color))));
var SliderBox = (cov_1cnbyy3c0f().s[2]++, (0, _styledComponents.default)(_gridStyled.Box).attrs({
  className: 'stx-PriceRangeFilter-SliderBox'
})(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)([""]))));
cov_1cnbyy3c0f().s[3]++;
var emptyFn = function emptyFn() {
  cov_1cnbyy3c0f().f[0]++;
};

/**
 * The component that handle filter price with minPrice and max Price
 */
var PriceRangeFilter = /*#__PURE__*/function (_PureComponent) {
  function PriceRangeFilter(props) {
    var _this;
    (0, _classCallCheck2.default)(this, PriceRangeFilter);
    cov_1cnbyy3c0f().f[1]++;
    cov_1cnbyy3c0f().s[4]++;
    _this = _callSuper(this, PriceRangeFilter, [props]);
    /** called when sliding the price filter  */
    (0, _defineProperty2.default)(_this, "handleValueUpdate", (cov_1cnbyy3c0f().s[7]++, function (_ref) {
      var values = _ref.values;
      cov_1cnbyy3c0f().f[2]++;
      cov_1cnbyy3c0f().s[8]++;
      _this.setState(function (prevState) {
        cov_1cnbyy3c0f().f[3]++;
        cov_1cnbyy3c0f().s[9]++;
        return _objectSpread(_objectSpread({}, prevState), {}, {
          values: (0, _toConsumableArray2.default)(values)
        });
      });
      cov_1cnbyy3c0f().s[10]++;
      _this.props.onApplyFilter(values);
    }));
    var _ref2 = (cov_1cnbyy3c0f().s[5]++, props),
      minPrice = _ref2.minPrice,
      maxPrice = _ref2.maxPrice;
    cov_1cnbyy3c0f().s[6]++;
    _this.state = {
      values: [minPrice, maxPrice]
    };
    return _this;
  }
  (0, _inherits2.default)(PriceRangeFilter, _PureComponent);
  return (0, _createClass2.default)(PriceRangeFilter, [{
    key: "render",
    value: function render() {
      cov_1cnbyy3c0f().f[4]++;
      var values = (cov_1cnbyy3c0f().s[11]++, (cov_1cnbyy3c0f().b[1][0]++, this.props.values) && (cov_1cnbyy3c0f().b[1][1]++, this.props.values.length === 2) ? (cov_1cnbyy3c0f().b[0][0]++, this.props.values) : (cov_1cnbyy3c0f().b[0][1]++, this.state.values));
      var _ref3 = (cov_1cnbyy3c0f().s[12]++, this.props),
        minPrice = _ref3.minPrice,
        maxPrice = _ref3.maxPrice,
        currencyCode = _ref3.currencyCode;
      cov_1cnbyy3c0f().s[13]++;
      return /*#__PURE__*/_react.default.createElement(Wrapper, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 69,
          columnNumber: 7
        }
      }, /*#__PURE__*/_react.default.createElement(PriceBox, {
        my: 1,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 70,
          columnNumber: 9
        }
      }, /*#__PURE__*/_react.default.createElement(_price.default, {
        labelFrom: '',
        labelTo: ' - ',
        currencyCode: currencyCode,
        minAmount: values[0],
        maxAmount: values[1],
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 71,
          columnNumber: 11
        }
      })), /*#__PURE__*/_react.default.createElement(SliderBox, {
        my: 1,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 79,
          columnNumber: 9
        }
      }, /*#__PURE__*/_react.default.createElement(_rangeSlider.default, {
        min: minPrice,
        max: maxPrice,
        values: values,
        onValuesUpdated: this.handleValueUpdate,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 80,
          columnNumber: 11
        }
      })));
    }
  }]);
}(_react.PureComponent);
cov_1cnbyy3c0f().s[14]++;
PriceRangeFilter.propTypes = {
  /** The minimum price of the filter  */
  minPrice: _propTypes.default.number.isRequired,
  /** The maximum of price filter */
  maxPrice: _propTypes.default.number.isRequired,
  values: _propTypes.default.arrayOf(_propTypes.default.number),
  /** The currency of the price should be displayed */
  currencyCode: _propTypes.default.string.isRequired,
  /** The function call on filter price change and apply */
  onApplyFilter: _propTypes.default.func
};
cov_1cnbyy3c0f().s[15]++;
PriceRangeFilter.defaultProps = {
  onApplyFilter: emptyFn,
  values: undefined
};
var _default = exports.default = PriceRangeFilter;